import { Outlet } from 'react-router-dom'
import SubMenu from '../../components/SubMenu'

const HomeVisitas = () => {
  const subMenuItems = [
    {
      label: 'Carregamento',
      path: '/ConsultarVisitas/carregamento'
    },
    {
      label: 'Descarregamento',
      path: '/ConsultarVisitas/descarregamento'
    },
    {
      label: 'Aguardando Liberação',
      path: '/ConsultarVisitas/agendadas'
    },
    {
      label: 'Liberadas',
      path: '/ConsultarVisitas/liberadas'
    },
    {
      label: 'Confirmar Saida',
      path: '/ConsultarVisitas/finalizar'
    }
    // ... outros itens
  ]

  return (
    <>
      <div className='home-container'>
        <div className='home-content'>
          <div className='home-conteudo-pagina'>
            <SubMenu menuItems={subMenuItems} />
            <Outlet /> {/* Isso renderizará as sub-rotas */}
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeVisitas
